const original = window.fetch;

const PERMANENT_RULES = [
  {
    matcher: url => url.hostname.includes('cognito-identity'),
    // eslint-disable-next-line no-unused-vars
    modifier: url => new URL(`${process.env.VUE_APP_BE_BASE_URL}/iam/auth/identity`),
    headers: originalHeaders => ({
      ...originalHeaders,
      accept: '*/*',
      'accept-encoding': 'gzip, deflate, br, zstd',
    }),
  },
];

function normalizeUrl(input) {
  if (input instanceof URL) {
    return new URL(input.href);
  }
  if (input instanceof Request) {
    return new URL(input.url);
  }
  return new URL(input.toString(), window.location.origin);
}

window.fetch = async (input, init) => {
  try {
    let url = normalizeUrl(input);
    let modifiedHeaders = {};
    let modifiedInit = { ...init };
    PERMANENT_RULES.forEach(rule => {
      if (rule.matcher(url)) {
        url = rule.modifier(url);
        // Get original headers from either Request object or init
        const originalHeaders = input instanceof Request
          ? Object.fromEntries(input.headers.entries())
          : (init?.headers || {});
        modifiedHeaders = rule.headers(originalHeaders);
      }
    });
    if (Object.keys(modifiedHeaders).length > 0) {
      modifiedInit.headers = modifiedHeaders;
    }
    if (input instanceof Request) {
      // Preserve all original request properties
      const originalRequest = input.clone();
      modifiedInit = {
        method: originalRequest.method,
        body: originalRequest.method !== 'GET' && originalRequest.method !== 'HEAD' ? await originalRequest.clone().text() : undefined,
        credentials: originalRequest.credentials,
        cache: originalRequest.cache,
        mode: originalRequest.mode,
        referrer: originalRequest.referrer,
        referrerPolicy: originalRequest.referrerPolicy,
        integrity: originalRequest.integrity,
        keepalive: originalRequest.keepalive,
        signal: originalRequest.signal,
        ...modifiedInit,
      };
    }
    const modifiedInput = input instanceof Request
      ? new Request(url, {
        ...input,
        ...modifiedInit,
      })
      : url.href;
    return original(modifiedInput, modifiedInit);
  } catch (error) {
    console.error('Fetch interceptor error:', error);
    return original(input, init);
  }
};
